<template>
  <div id="common-data-table">
    <v-data-table
      hide-default-footer
      class="sc-data-table"
      :headers="headers"
      :items="items"
      :sort-by="sortBy[0]"
      :sort-desc="sortDesc[0]"
    >
      <template #header.multi="{ header }">
        <template v-for="item in header.multi">
          <BaseTableHeaderMulti
            :key="item.text"
            :header="item"
            :is-sort-descending="sortDesc[0]"
            :is-active="isActiveSort(item)"
            :color="isActiveSort(item) ? 'black' : 'grey'"
            @sortChangeEvent="sortChangeHandler"
          />
        </template>
      </template>
      <template #item="{ item }">
        <tr>
          <td>
            <span v-if="item.invoice_number">№{{ item.invoice_number }}</span>
            <span v-else class="record-id small"><strong>#{{ item._key }}</strong></span>
          </td>
          <td>
            <div class="small">{{ item.invoice_date | formatDate }}</div>
          </td>
          <td>{{ item.amount | formatCurrency }}</td>
          <td>{{ item.due_date | formatDate }}</td>
          <td :style="`color: ${item.color}`">{{ item.status | capitalize }}</td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';

import { getInvoiceStatusProps } from '@/bundles/Deal/helpers';
import { IHeader } from '@/bundles/BaseTable/interfaces';

import BaseTableHeaderMulti from '@/bundles/BaseTable/components/BaseTableHeaderMulti.vue';

const headers: IHeader[] = [
  {
    multi: [{ text: 'Invoice #', sortable: true, value: 'invoice_number', icon: 'number' }],
    value: 'multi',
    sortable: false
  },
  {
    multi: [{ text: 'Invoice Date', sortable: true, value: 'invoice_date', icon: 'date' }],
    value: 'multi',
    sortable: false
  },
  {
    multi: [{ text: 'Invoice Amount', sortable: true, value: 'amount', icon: 'number' }],
    value: 'multi',
    sortable: false
  },
  {
    multi: [{ text: 'Due Date', sortable: true, value: 'due_date', icon: 'date' }],
    value: 'multi',
    sortable: false
  },
  {
    multi: [{ text: 'Status', sortable: true, value: 'status', icon: 'text' }],
    value: 'multi',
    sortable: false
  }
];

export default Vue.extend({
  name: 'OpenBalancesInvoiceTable',

  components: {
    BaseTableHeaderMulti
  },

  props: {
    itemsEntry: {
      type: Array as PropType<any>,
      default: () => []
    }
  },

  data: () => ({
    headers,
    items: [],
    sortBy: ['due_date'],
    sortDesc: [true]
  }),

  mounted () {
    this.items = this.itemsEntry.map(item => {
      const { status, color } = getInvoiceStatusProps(item);
      return {
        ...item,
        status,
        color
      };
    });
  },

  methods: {
    isActiveSort: function (item: IHeader): boolean {
      return this.sortBy[0] === item.value;
    },
    sortChangeHandler (payload: { sortBy: [string]; sortDesc: [boolean] }) {
      const { sortBy, sortDesc } = payload;
      this.sortBy = sortBy;
      this.sortDesc = sortDesc;
    },
  }
})
</script>
